/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,updateCategory,setQuote,initQuote,setLogo, setTotalPrice, setGst} from '../actions/quote'
import Category from "./Category.js"
import {supplier_arry} from "../config"
import { toast } from 'react-toastify';

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";


function Index(props) {
  
  const quote = props.quote;
  const categories = quote.categories;

  useEffect(() => {
  },[quote]);

  const getCategorySum = ()=>{
    var sum = 0;
    const categories = quote.categories;
    for(var index in categories){
      const category = categories[index]
      var removed_fee = category['removed_fee'];
      var groups = category.items
      if(groups){
        var group = groups[0];
        var group_options = group['group_options'];
        for(var loop = 0; loop< supplier_arry.length; loop++){
          var catalog = supplier_arry[loop]['key'];
          if(group_options && group_options['cat_fee_'+catalog]){
            if(!removed_fee || (removed_fee && removed_fee.length == 0) || (removed_fee && !removed_fee.includes(catalog))){
              sum+= (group_options['cat_fee_'+catalog]*1)
            }
          }
        }
      }
    }
    return sum;
  }
  const totalMargin=()=>{
   
  }
  const totalMarginPercent=()=>{
    
  }
  var role = props.role
  
  var total = 0;
  var discountSum = 0;
  var category = null;
  var group;
  var items = [];
  var groupoptions = {};
  var tasks = [];
  var customs = [];
  var sum_fee = 0;
  var costDiscountSum = 0;
  var priceDiscountSum = 0;
  if(categories && categories[0]){
    category = categories[0]
    var groups = [...category.items]
    if(groups && groups.length>0){
      items = groups[0]
      if(items){
        for(var loop = 0; loop < items.length; loop++){
          var item = items[loop];
          if(item.type == "product"){
          }
          else if(item.type == "decoration"){
            var discounts = item['discounts'];
            if(discounts && discounts.length > 0){
              for(var discountInd = 0; discountInd < discounts.length; discountInd++){
                var discountItem = discounts[discountInd]
                var setup_discount_cost = !isNaN(discountItem['setup_discount_cost'])&&discountItem['setup_discount_cost']?discountItem['setup_discount_cost']:0;
                var setup_discount_value = !isNaN(discountItem['setup_discount_value'])&&discountItem['setup_discount_value']?discountItem['setup_discount_value']:0;
                var setup_discount_qty = !isNaN(discountItem['setup_discount_qty'])&&discountItem['setup_discount_qty']?discountItem['setup_discount_qty']:0;
                
                costDiscountSum += setup_discount_cost*setup_discount_qty 
                priceDiscountSum += setup_discount_value*setup_discount_qty
              }
            }

          }
          else if(item.type == "delivery"){
            var qty=1
            var price = !isNaN(item['delivery_discount'])&&item['delivery_discount']?item['delivery_discount']:0;
            var cost = !isNaN(item['delivery_discount'])&&item['delivery_discount']?item['delivery_discount']:0;     
         
            costDiscountSum +=(qty*cost);
            priceDiscountSum +=(qty*price);
          }
          else if(item.type == "discount"){
            var qty = !isNaN(item['discount_qty'])&&item['discount_qty']?item['discount_qty']:0;
            var price = !isNaN(item['discount_price'])&&item['discount_price']?item['discount_price']:0;
            var cost = !isNaN(item['discount_unit_cost'])&&item['discount_unit_cost']?item['discount_unit_cost']:0;           
            costDiscountSum +=(qty*cost);
            priceDiscountSum +=(qty*price);
          }
        }
      }

      groupoptions = items['group_options'];
      if(groupoptions){
        if(groupoptions['customs'])
          customs = groupoptions['customs']
        var customfees = groupoptions['customfees'];
        if(customfees && customfees.length>0){
          for(var i = 0; i < customfees.length; i++){
            sum_fee+= customfees[i]['customfee_price']* customfees[i]['customfee_qty']
          }
        }
        var discount = items['group_options']['discount'];
        if(discount){
          var discount_qty = discount['qty']?discount['qty']*1:0;
          var discount_price = discount['price']?(discount['price']*1):0;
          var discount_cost = discount['cost']?(discount['cost']*1):0;

          if(isNaN(discount_qty)) discount_qty = 0;
          if(isNaN(discount_price)) discount_price = 0;
          if(isNaN(discount_cost)) discount_cost = 0;

          costDiscountSum +=(discount_qty*discount_cost);
          priceDiscountSum +=(discount_qty*discount_price);
        }
      }

    }
  }

  var gstPrice = (props.quote && props.quote.totalPrice)?props.quote.totalPrice/10:0
  return (
    <>
      <div>
        {/* render products, decorations, delivery */}
        {sum_fee >0 &&
          <div className="d-flex justify-content-between summary-item">
            <div className="custom-control custom-checkbox m-0 yellow">
              <input
                className="custom-control-input"
                id={`product-accept-check-sum`}
                type="checkbox"
                checked={true}
                // checked={item.unaccepted?false:true}
                // value="1"
                // onChange={(e)=>props.onChangeProduct(0, index, 'unaccepted', !item.unaccepted)}
              />
              <label className="custom-control-label" htmlFor={`product-accept-check-sum`}>
                Catalogue Fee
              </label>
            </div>
            <div>          
              ${sum_fee.toFixed(2)}
            </div>
          </div>
        }
        {items && items.length > 0 && 
          <>
          {
            items.map((item, index)=>{
              var element = [];
              if(item.type == 'product' && (item.qty*1)>0){
                element.push (
                  <div key={index} className="d-flex justify-content-between summary-item">
                    <div className="custom-control custom-checkbox m-0 yellow">
                      <input
                        className="custom-control-input"
                        id={`product-accept-check-${index}`}
                        type="checkbox"
                        checked={true}
                        // checked={item.unaccepted?false:true}
                        // value="1"
                        // onChange={(e)=>props.onChangeProduct(0, index, 'unaccepted', !item.unaccepted)}
                      />
                      <label className="custom-control-label" htmlFor={`product-accept-check-${index}`}>
                        {item.code} x{item.qty}
                      </label>
                    </div>
                    <div>          
                      ${((item.price?(item['price']*1).toFixed(2):0)*(item.qty?item.qty:0)).toFixed(2)}
                    </div>
                  </div>
                )
              }
              if(item.type == 'decoration' && (item.qty*1)>0){
                element.push (
                  <div key={index} className="d-flex justify-content-between summary-item">
                    <div className="custom-control custom-checkbox m-0 yellow">
                      <input
                        className="custom-control-input"
                        id={`decoration-check-${index}`}
                        type="checkbox"
                        checked={true}
                        // checked={item.unaccepted?false:true}
                        // value="1"
                        // onChange={(e)=>props.onChangeEmbDecoration(0, 'unaccepted', !item.unaccepted, index)}
                      />
                      <label className="custom-control-label" htmlFor={`decoration-check-${index}`}>
                        {item.code} x{item.qty}
                      </label>
                    </div>
                    <div>          
                      ${((item.price?item.price:0)*(item.qty?item.qty:0)).toFixed(2)}
                    </div>
                  </div>
                )
                if(item.setup_code && item.setup_code!='' && item.setup_code!='None' && item.setup_qty>0){
                  element.push (
                    <div className="d-flex justify-content-between summary-item">
                      <div className="custom-control custom-checkbox m-0 yellow">
                        <input
                          className="custom-control-input"
                          id={`setup-check-${index}`}
                          type="checkbox"
                          checked={true}
                          // checked={item.setup_unaccepted?false:true}
                          // value="1"
                          // onChange={(e)=>props.onChangeEmbDecoration(0, 'setup_unaccepted', !item.setup_unaccepted, index)}
                        />
                        <label className="custom-control-label" htmlFor={`setup-check-${index}`}>
                          {item.setup_code} x{item.setup_qty}
                        </label>
                      </div>
                      <div>          
                        ${((item.setup_qty?item.setup_qty:0)*(item.setup_price?item.setup_price:0)).toFixed(2)} 
                      </div>
                    </div>
                  )
                }
                if(item?.code?.includes("Screen Print")&& item.setup_color_change && item.setup_color_change!='' && item.setup_color_change_qty>0){
                  element.push (
                    <div className="d-flex justify-content-between summary-item">
                      <div className="custom-control custom-checkbox m-0 yellow">
                        <input
                          className="custom-control-input"
                          id={`setup-check-${index}`}
                          type="checkbox"
                          checked={true}
                          // checked={item.setup_unaccepted?false:true}
                          // value="1"
                          // onChange={(e)=>props.onChangeEmbDecoration(0, 'setup_unaccepted', !item.setup_unaccepted, index)}
                        />
                        <label className="custom-control-label" htmlFor={`setup-check-${index}`}>
                          {item.setup_color_change} x{item.setup_color_change_qty}
                        </label>
                      </div>
                      <div>          
                        ${((item.setup_color_change_qty?item.setup_color_change_qty:0)*(item.setup_color_change_price?item.setup_color_change_price:0)).toFixed(2)} 
                      </div>
                    </div>
                  )
                }
                // if(item.discounts && item.discounts.length > 0){
                //   var discounts = item.discounts;
                //   for(var discountInd = 0; discountInd < discounts.length; discountInd++){
                //     var discount = discounts[discountInd];
                //     if(discount.setup_discount && discount.setup_discount!='' && discount.setup_discount_qty){
                //       element.push (
                //         <div className="d-flex justify-content-between summary-item">
                //           <div className="custom-control custom-checkbox m-0 yellow">
                //             <input
                //               className="custom-control-input"
                //               id={`setupdiscount-check-${index}-${discountInd}`}
                //               type="checkbox"
                //               checked={true}
                //             />
                //             <label className="custom-control-label" htmlFor={`setupdiscount-check-${index}-${discountInd}`}>
                //               {discount.setup_discount} x{discount.setup_discount_qty}
                //             </label>
                //           </div>
                //           <div>          
                //             ${((discount.setup_discount_qty?discount.setup_discount_qty:0)*(discount.setup_discount_value?discount.setup_discount_value:0)).toFixed(2)} 
                //           </div>
                //         </div>
                //       )
                //     }
                //   }
                // }
              }
              if(item.type == 'delivery' && (item.delivery_qty*1)>0){
                element.push (
                  <div key={index} className="d-flex justify-content-between summary-item">
                    <div className="custom-control custom-checkbox m-0 yellow">
                      <input
                        className="custom-control-input"
                        id={`delivery-check-${index}`}
                        type="checkbox"
                        checked={true}
                        // checked={item.unaccepted?false:true}
                        // value="1"
                        // onChange={(e)=>props.onChangeEmbDecoration(0, 'unaccepted', !item.unaccepted, index)}
                      />
                      <label className="custom-control-label" htmlFor={`delivery-check-${index}`}>
                        Delivery - {item.delivery_desc} x{item.delivery_qty}
                      </label>
                    </div>
                    <div>          
                      ${((item.delivery_price?item.delivery_price:0)*(item.delivery_qty?item.delivery_qty:0)-(item['delivery_discount']?item['delivery_discount']*1:0)).toFixed(2)}
                    </div>
                  </div>
                )
              }
              // if(item.type == 'discount' && (item.discount_qty*1)>0){
              //   element.push (
              //     <div className="d-flex justify-content-between summary-item">
              //       <div className="custom-control custom-checkbox m-0 yellow">
              //         <input
              //           className="custom-control-input"
              //           id={`discount-check-${index}`}
              //           type="checkbox"
              //           checked={true}
              //           // checked={item.unaccepted?false:true}
              //           // value="1"
              //           // onChange={(e)=>props.onChangeEmbManage(0, "unaccepted", !item.unaccepted, index)}
              //         />
              //         <label className="custom-control-label" htmlFor={`discount-check-${index}`}>
              //           Discount x{item.discount_qty}
              //         </label>
              //       </div>
              //       <div>          
              //         ${((item.discount_price?item.discount_price:0)*(item.discount_qty?item.discount_qty:0)).toFixed(2)}
              //       </div>
              //     </div>
              //   )
              // }
              return element;
            })
          }
          </>
        }
        {
          customs.map((custom, index)=>{
            var tasks = custom['tasks']
            var element = [];
            if(tasks && tasks.length>0){
              var template = (props.templates || []).find(template => template.uuid == custom.custom_code);
              var templatename = template ? template.name : 'None';
              tasks.map((item, task_ind)=>{
                if((item.task_qty*1) > 0){
                  var taskname = item.task_label || 'None';
                  for(var i = 0; i< props.tasks.length; i++){
                    if(props.tasks[i]['uuid'] == item.task_name){
                      taskname = props.tasks[i]['name']
                    }
                  }
                  if(item['task_checked'] || role == "admin"){
                    element.push (
                      <div key={`task-${index}-${task_ind}`} className="d-flex justify-content-between summary-item">
                        <div className="custom-control custom-checkbox m-0 yellow">
                          <input
                            className="custom-control-input"
                            id={`custom-check-${task_ind}-${index}`}
                            type="checkbox"
                            checked={true}
                            // checked={item.unaccepted?false:true}
                            // value="1"
                            // onChange={(e)=>props.onChangeEmbCustomTask(0, "unaccepted", !item.unaccepted, index, task_ind)}
                          />
                          <label className="custom-control-label" htmlFor={`custom-check-${task_ind}-${index}`}>
                            {taskname} x{item.task_qty}
                          </label>
                        </div>
                        <div>          
                          ${((item.task_price?item.task_price:0)*(item.task_qty?item.task_qty:0)).toFixed(2)}
                        </div>
                      </div>
                    )
                  }
                }
              })
            }
            return element
          })
        }
        {(costDiscountSum != 0 || priceDiscountSum != 0) &&
        <div className="d-flex justify-content-between summary-item">
          <div className="custom-control custom-checkbox m-0 yellow">
            <input
              className="custom-control-input"
              type="checkbox"
              checked={true}
              // checked={item.unaccepted?false:true}
              // value="1"
              // onChange={(e)=>props.onChangeEmbManage(0, "unaccepted", !item.unaccepted, index)}
            />
            <label className="custom-control-label">
              Discount 
            </label>
          </div>
          <div>          
            ${priceDiscountSum.toFixed(2)}
          </div>
        </div>
        }
      </div>
      <hr/>
      <div className="d-flex justify-content-between">
        <div><b className="font-14">GST</b></div>
        <div><b className="font-14">${(gstPrice).toFixed(2)} </b></div>
      </div>
      <div className="d-flex justify-content-between">
        <div><b className="font-14">Total GST(ex)</b></div>
        <div><b className="font-14">${(props.quote.totalPrice?props.quote.totalPrice*1:0).toFixed(2)}</b></div>
      </div>
      <div className="d-flex justify-content-between">
        <div><b className="font-14">Total</b></div>
        <div><b className="font-14">${(props.quote.totalPrice?(props.quote.totalPrice*1+props.quote.totalPrice/10):0).toFixed(2)}</b></div>
      </div>
      <hr/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    setTotalPrice: value=>dispatch(setTotalPrice(value)),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    setQuote: quote=>dispatch(setQuote(quote)),
    initQuote:()=>dispatch(initQuote()),
    setLogo:logo=>dispatch(setLogo(logo)),
    setGst: value=>dispatch(setGst(value)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
